<template>
  <base-section
  id="submissions"
  >
    <v-container>
    <base-section-heading
    title="Submissions"
    color="red"
    :toColor="true"
    align="left"
    >
DDECS‘25 seeks original, unpublished contributions of the following types:<br />

•	<strong>Regular Papers (6 pages)</strong> presenting novel and complete research work <br />
•	<strong>Student Papers (4 pages)</strong> from students eager to discuss their on-going research<br />
<br />
<strong>Additional information</strong>: DDECS’25 will produce Formal Proceedings of accepted papers with ISBN number that will be included in the IEEE Xplore Digital Library. An Informal digest will be produced to include additional conference contents.
<br /><br />
Click <a
    href="https://www.conftool.org/ddecs2025/"
    target="_blank"
    ><b>here</b></a> to submit your paper.
    <br />
    <br />
    <v-btn
        href="https://www.conftool.org/ddecs2025/"
        rounded
        color="primary"
        dark
        style="padding: 15px"
        target="_blank"
    >
        <v-icon
        left
        dark
        >
        mdi-open-in-new
        </v-icon>
        Submission Website
        </v-btn>
    </base-section-heading>
    <base-section-heading
    title="Key Dates"
    color="red"
    :toColor="true"
    align="left"
    >
<strong>
Submission Deadline (Title and Abstract): <span style="color: #808080"><s>January 8th, 2025</s></span> <strong><span style="color: #003399">January 13th, 2025</span> <span style="color: red;">(Extended Deadline)</span> </strong><br />
Submission Deadline (Full Paper):  <span style="color: #808080"><s>January 13th, 2025</s></span> <strong><span style="color: #003399">January 20th, 2025</span> <span style="color: red;">(Extended Deadline)</span></strong><br />
Notification of Acceptance: <span style="color: #003399"> <strong>February 24th, 2025</strong></span><br />
Camera Ready: <span style="color: #003399"><strong>March 10th, 2025</strong></span><br />
Early registration: <span style="color: #003399"><strong>April 5th, 2025</strong></span><br />

<br>
</strong>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Submissions',

    data: () => ({
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
